import styles from './AddQuiz.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import { TextInput, TextInputValue } from 'src/components/text-input/TextInput';
import { useCallback, useEffect, useState } from 'react';
import Spinner from '@src/components/spinner/Spinner';
import { QuizFragment } from '@src/api/graphql-codegen';
import RemoveIcon from 'src/assets/icons/study-remove.svg?react';

type Props = {
  open: boolean;
  creating: boolean;
  quiz?: QuizFragment;
  quizzes: QuizFragment[];
  onClose: () => void;
  onUpdateCourse: (id: string, name: string, unitId?: string) => void;
  onRemoveCourse?: (id: string) => void;
  unitId?: string;
};

function EditCourse(props: Props) {
  const { open, creating, quiz, quizzes, onClose, onUpdateCourse, onRemoveCourse, unitId } = props;
  const [ name, setName ] = useState(quiz?.name ?? "")
  const [ error, setError ] = useState("")


  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    const onPageLoad = () => {
      const item = document.getElementById("name")
      if (item) {
        item.focus();
      }
    };
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      return () => window.removeEventListener('load', onPageLoad);
    }

  }, [])

  const handleChange = (value: TextInputValue) => {
    setName(value.toString())
    setError('')
  }
  const handleUpdateNew = useCallback(() => {
    if (quiz && name) {
      if (name === quiz?.name) {
        onClose();
        return;
      }
      const exist = quizzes.find(plan => plan.name.toLocaleLowerCase() === name.toLocaleLowerCase())
      if (exist) {
        setError(`${name} is exist already, Assessment name should be unique.`)
        return;
      }
      unitId ? onUpdateCourse(quiz.id, name, unitId) : onUpdateCourse(quiz.id, name)
    }
  }, [quiz, name, quizzes, unitId, onUpdateCourse, onClose])

  const handleRemoveCourse = useCallback(() => {
    if (quiz && onRemoveCourse) {
      onRemoveCourse(quiz.id);
    }
  }, [quiz, onRemoveCourse])


  return (
    <Modal open={open} onClose={handleClose} className={styles.editWrapper}>
      <div>
        <div className={styles.title}>{quiz?.name === "" ? 'Name this Assessment' : 'Edit Assessment'}</div>
        <div className={styles.content}>
          <TextInput hasError={error!==''} subTitle={error} id="name" placeholder={quiz?.name === "" ? 'No name' :'Assessment name'} value={name} label={quiz?.name === "" ? '' : 'Assessment name'} onChange={handleChange} />
          { quiz?.name === "" ?
          <div className={styles.editAction}>
            <Button disabled={creating || (!quiz && !name)} size="small" leftIcon={creating ? <Spinner width={20} height={20} /> : undefined} className={styles.okButton} onClick={handleUpdateNew} label={'OK'}/>
          </div> :
          <div className={styles.editAction}>
            <Button disabled={false} size="small" leftIcon={creating ? <Spinner width={20} height={20} /> : <RemoveIcon width={14} height={14} />} className={styles.removeButton} onClick={handleRemoveCourse} label={'Remove Assessment'}/>
            <Button disabled={creating || !name} size="small" leftIcon={creating ? <Spinner width={20} height={20} /> : undefined} className={styles.okButton} onClick={handleUpdateNew} label={'SAVE'}/>
          </div>}
        </div>
      </div>
    </Modal>
  );
}

export default EditCourse;
